import {
  AuthStatus,
  AuthStatusChangedHandler,
  Server,
  fullPhoneNumber,
} from '@nextforce/api'
import { AuthenticationService } from 'authentication/types'
import { Platform } from 'react-native'

export class ServerAuthenticationService implements AuthenticationService {
  private status: AuthStatus = 'loading'
  private statusChangedHandler?: AuthStatusChangedHandler

  constructor(private server: Server) {
    this.server.setAuthStatusChangeHandler(status => {
      this.status = status
      this.updateStatus()
    })
  }

  async login(phoneNumber: string, code: string): Promise<any> {
    await this.server.authenticate(fullPhoneNumber(phoneNumber), code)
    if (Platform.OS === 'web') {
      await this.server.restoreSession?.()
    }
    this.updateStatus()
  }

  async loginViaAuthCode(code: string): Promise<any> {
    await this.server.authenticateViaAuthCode(code)
    if (Platform.OS === 'web') {
      await this.server.restoreSession?.()
    }
    this.updateStatus()
  }

  async logout() {
    await this.server.deauthenticate()
    this.updateStatus()
  }

  onStatusChanged(handler?: AuthStatusChangedHandler) {
    if (this.statusChangedHandler !== handler) {
      this.statusChangedHandler = handler
      this.updateStatus()
    }
  }

  private updateStatus() {
    this.statusChangedHandler?.(this.status)
  }
}
